import { ReportPage } from 'types/reporting/reportPage';
import {
    BillableHoursByEmployeeAndMonthRow,
    BillableHoursByEmployeeAndYearRow,
    BillableHoursByEmployeeAndYearTotals,
    BillableHoursByMonthRow,
    BillableHoursByYearRow,
    BillableHoursByYearTotals,
    BillableHoursTotals,
    InvoicedWorkByEmployeeAndMonthRow,
    InvoicedWorkByEmployeeAndYearRow,
    InvoicedWorkTotals,
} from 'types/reporting/trends';
import { portalAPI } from './portalAPI';
import { reportQuery } from './util/reportQuery';

const reportingTrendsApi = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        getBillableHoursByMonthReport: reportQuery<ReportPage<BillableHoursByMonthRow, BillableHoursTotals>>(
            builder,
            '/v1/reporting/billable-hours-by-month'
        ),
        // The report takes no filter, so it is a plain query rather than a list fetch.
        getBillableHoursByYearReport: builder.query<
            ReportPage<BillableHoursByYearRow, BillableHoursByYearTotals>,
            void
        >({ query: () => '/v1/reporting/billable-hours-by-year', keepUnusedDataFor: 0 }),
        getInvoicedWorkByEmployeeAndMonthReport: reportQuery<
            ReportPage<InvoicedWorkByEmployeeAndMonthRow, InvoicedWorkTotals>
        >(builder, '/v1/reporting/invoiced-work-by-employee-and-month'),
        getInvoicedWorkByEmployeeAndYearReport: reportQuery<
            ReportPage<InvoicedWorkByEmployeeAndYearRow, InvoicedWorkTotals>
        >(builder, '/v1/reporting/invoiced-work-by-employee-and-year'),
        getBillableHoursByEmployeeAndMonthReport: reportQuery<
            ReportPage<BillableHoursByEmployeeAndMonthRow, BillableHoursTotals>
        >(builder, '/v1/reporting/billable-hours-by-employee-and-month'),
        getBillableHoursByEmployeeAndYearReport: reportQuery<
            ReportPage<BillableHoursByEmployeeAndYearRow, BillableHoursByEmployeeAndYearTotals>
        >(builder, '/v1/reporting/billable-hours-by-employee-and-year'),
    }),
});

export const {
    useLazyGetBillableHoursByMonthReportQuery,
    useGetBillableHoursByYearReportQuery,
    useLazyGetInvoicedWorkByEmployeeAndMonthReportQuery,
    useLazyGetInvoicedWorkByEmployeeAndYearReportQuery,
    useLazyGetBillableHoursByEmployeeAndMonthReportQuery,
    useLazyGetBillableHoursByEmployeeAndYearReportQuery,
} = reportingTrendsApi;
